

export const FETCH_ORDERS = 'FETCH_ORDERS';
export const FETCH_ORDERS_SUCCESS = 'FETCH_ORDERS_SUCCESS';
export const FETCH_ORDERS_FAIL = 'FETCH_ORDERS_FAIL';
export const DELETE_ORDER = 'DELETE_ORDER';
export const UPDATE_ORDER = 'UPDATE_ORDER';

export const OrderStatus = {draft:'Planerad', booked:'Bokad', confirmed: 'Bekräftad', completed:'Genomförd'};


// WEBPACK FOOTER //
// ./src/data/orders/types.js